
const TechBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
      {/* Floating geometric shapes */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-nexx-green/5 rounded-full animate-pulse"></div>
      <div className="absolute top-40 right-20 w-24 h-24 bg-blue-500/5 rounded-lg rotate-45 animate-bounce" style={{ animationDuration: '3s' }}></div>
      <div className="absolute bottom-40 left-20 w-20 h-20 bg-green-500/5 rounded-full animate-ping" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
      <div className="absolute bottom-20 right-40 w-16 h-16 bg-nexx-green/5 rounded-lg animate-pulse" style={{ animationDelay: '2s' }}></div>
      
      {/* Circuit-like lines */}
      <div className="absolute top-32 left-1/4 w-px h-32 bg-gradient-to-b from-nexx-green/20 to-transparent animate-pulse"></div>
      <div className="absolute top-60 right-1/3 w-24 h-px bg-gradient-to-r from-nexx-green/20 to-transparent animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      <div className="absolute bottom-32 left-1/3 w-px h-24 bg-gradient-to-t from-blue-500/20 to-transparent animate-pulse" style={{ animationDelay: '3s' }}></div>
      
      {/* Data particles */}
      <div className="absolute top-1/4 right-1/4 w-2 h-2 bg-nexx-green rounded-full animate-ping" style={{ animationDelay: '0.5s', animationDuration: '2s' }}></div>
      <div className="absolute top-3/4 left-1/3 w-1 h-1 bg-blue-500 rounded-full animate-ping" style={{ animationDelay: '2.5s', animationDuration: '3s' }}></div>
      <div className="absolute top-1/2 right-1/5 w-1.5 h-1.5 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '4s', animationDuration: '2.5s' }}></div>
    </div>
  );
};

export default TechBackground;
